var EqualHeights = function(container, items){

	var _container = $(container),
		_items = $(items, container)

	function _setHeight() {
		var colNum = Math.floor(_container.width() / _items.width())


		if(colNum < 2) {
			_items.css('height', 'auto')
		}

		if(!colNum || colNum < 2) return false;

		for(var i = 0, j = _items.length; i < j; i+=colNum) {
			var maxHeight = 0,
				row = _items.slice(i, i + colNum)

			row.css('height', 'auto');

			for(var m = 0, n = row.length; m < n; m++) {
				var ith = $(row[m]).height();
				//console.log(ith, maxHeight)
				maxHeight = ith > maxHeight ? ith : maxHeight;
			}
			row.css('height', maxHeight);
			//console.log('maxheight: ', maxHeight);
		}
	}

	this.setHeight = _setHeight;

	//return this;

};